import { firstValueFrom } from "rxjs";
import { api } from "../../common/api/index.ts";
import { LoginStatus } from "../../common/types.ts";
import { loginStatus$ } from "../store/loginV2.ts";
import { suggestions } from "../store/suggestions.ts";

const getSuggestion = api.path("/api/suggestion").method("get").create();

export async function getSuggestions() {
	const loginStatus = await firstValueFrom(loginStatus$);
	if (loginStatus.status !== LoginStatus.LOGGED_IN) {
		throw new Error("need to be logged in to load suggestions");
	}
	const { data } = await getSuggestion(
		{},
		{ headers: { authorization: `Bearer ${loginStatus.token}` } },
	);

	suggestions.set(data);
}
